import Dish from './Dish'
import './Dish.css'

export default Dish



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/containers/Dish/index.js